import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-2xl font-bold mb-6" }
const _hoisted_2 = { class: "text-black text-left font-light text-xs leading-relaxed whitespace-pre-line" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_6 = ["src", "alt", "onClick"]
const _hoisted_7 = { class: "flex gap-1.5 h-1" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "absolute left-0 right-0 mt-10 transition-all duration-300" }
const _hoisted_10 = { class: "bg-brand-main rounded-xl p-2 text-white text-center relative" }
const _hoisted_11 = { class: "text-xs leading-relaxed" }

import { ref, computed, onMounted, onUnmounted, watch } from "vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'DiamondDetailColorContent',
  props: {
    color: { default: "G" },
    colored: { type: Boolean, default: false },
    mobileMode: { type: Boolean, default: false }
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

const host = process.env.VUE_APP_HOST;

const colors = [
  {
    key: "j",
    label: "J",
    img: "/img/diamonds/details/color_j.webp",
  },
  {
    key: "i",
    label: "I",
    img: "/img/diamonds/details/color_i.webp",
  },
  {
    key: "h",
    label: "H",
    img: "/img/diamonds/details/color_h.webp",
  },
  {
    key: "g",
    label: "G",
    img: "/img/diamonds/details/color_g.webp",
  },
  {
    key: "f",
    label: "F",
    img: "/img/diamonds/details/color_f.webp",
  },
  {
    key: "e",
    label: "E",
    img: "/img/diamonds/details/color_e.webp",
  },
  {
    key: "d",
    label: "D",
    img: "/img/diamonds/details/color_d.webp",
  },
];

const colorValue = computed(() => Array.isArray(props.color) ? props.color[0] : props.color);

const getInitialIndex = () => {
  if (!colorValue.value) return 6;
  const index = colors.findIndex((c) => c.key === colorValue.value!.toLowerCase());
  return index !== -1 ? index : 6;
};

const selectedIndex = ref(getInitialIndex());

const isMobile = ref(window.innerWidth < 769);
const updateMobile = () => {
  isMobile.value = window.innerWidth < 769;
};

const isMobileMode = computed(() => props.mobileMode || isMobile.value);

watch(() => props.color, () => {
  selectedIndex.value = getInitialIndex();
});

const sliderRef = ref<HTMLElement | null>(null);
const isDragging = ref(false);

const updateIndexFromEvent = (e: MouseEvent | TouchEvent) => {
  if (!sliderRef.value) return;
  const rect = sliderRef.value.getBoundingClientRect();
  const clientX =
    "touches" in e ? e.touches[0].clientX : (e as MouseEvent).clientX;
  const offsetX = clientX - rect.left;
  let percentage = offsetX / rect.width;
  percentage = Math.max(0, Math.min(0.99, percentage));
  selectedIndex.value = Math.floor(percentage * 7);
};

const startDragging = (e: MouseEvent | TouchEvent) => {
  if (props.colored) return;
  isDragging.value = true;
  updateIndexFromEvent(e);
};

const handleMove = (e: MouseEvent | TouchEvent) => {
  if (isDragging.value) {
    updateIndexFromEvent(e);
  }
};

const stopDragging = () => {
  isDragging.value = false;
};

onMounted(() => {
  window.addEventListener("mousemove", handleMove);
  window.addEventListener("mouseup", stopDragging);
  window.addEventListener("touchmove", handleMove, { passive: false });
  window.addEventListener("touchend", stopDragging);
  window.addEventListener("resize", updateMobile);
});

onUnmounted(() => {
  window.removeEventListener("mousemove", handleMove);
  window.removeEventListener("mouseup", stopDragging);
  window.removeEventListener("touchmove", handleMove);
  window.removeEventListener("touchend", stopDragging);
  window.removeEventListener("resize", updateMobile);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['flex flex-col items-center ', isMobileMode.value ? '' : 'md:gap-12 md:flex-row'])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['w-full text-left', isMobileMode.value ? '' : 'md:w-1/3'])
    }, [
      _renderSlot(_ctx.$slots, "title", {
        selectedLabel: __props.colored ? colorValue.value : colors[selectedIndex.value].label
      }, () => [
        _createElementVNode("h3", _hoisted_1, _toDisplayString(_unref(t)("components.diamonds.details.color.title")) + ": " + _toDisplayString(__props.colored ? colorValue.value : colors[selectedIndex.value].label), 1)
      ]),
      _createElementVNode("p", _hoisted_2, [
        (__props.colored && colorValue.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_unref(t)(
              "components.diamonds.details.color.colored." +
                colorValue.value.toLowerCase() +
                ".text"
            )), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_unref(t)("components.diamonds.details.color.content_text")), 1)
            ], 64))
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(['w-full', isMobileMode.value ? '' : 'md:w-2/3'])
    }, [
      (__props.colored && colorValue.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("img", {
              src: 
            _unref(host) +
            '/img/diamonds/filter/color/' +
            colorValue.value.toUpperCase() +
            '@2x.jpg'
          ,
              class: "h-full max-h-64 mx-auto rounded-md"
            }, null, 8, _hoisted_4)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(['flex justify-center items-end mb-6', isMobileMode.value ? '' : 'md:justify-between'])
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(colors, (c, index) => {
                return _createElementVNode("div", {
                  key: c.key,
                  class: _normalizeClass(["justify-center px-2 flex", [
              selectedIndex.value === index ? 'flex' : (isMobileMode.value ? 'hidden' : 'hidden md:flex'),
              isMobileMode.value ? '' : 'md:flex-1',
            ]])
                }, [
                  _createElementVNode("img", {
                    src: _unref(host) + c.img,
                    alt: c.label,
                    class: _normalizeClass(["transition-opacity duration-300 cursor-pointer", [
                isMobileMode.value ? 'h-52 w-80 object-cover max-w-[420px]' : 'max-w-[420px] md:w-full',
                { 'md:opacity-90': !isMobileMode.value && selectedIndex.value !== index }
              ]]),
                    onClick: ($event: any) => (selectedIndex.value = index)
                  }, null, 10, _hoisted_6)
                ], 2)
              }), 64))
            ], 2),
            _createElementVNode("div", {
              class: "relative pb-32 cursor-pointer",
              ref_key: "sliderRef",
              ref: sliderRef,
              onMousedown: startDragging,
              onTouchstart: _withModifiers(startDragging, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(colors, (c, index) => {
                  return _createElementVNode("div", {
                    key: 'bar-' + c.key,
                    class: "flex-1 cursor-pointer relative group",
                    onClick: ($event: any) => (selectedIndex.value = index)
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["h-full w-full rounded-full transition-colors duration-300", 
                  selectedIndex.value === index ? 'bg-brand-main' : 'bg-brand-main/30'
                ])
                    }, null, 2),
                    _createElementVNode("span", {
                      class: _normalizeClass(["absolute top-2 left-1/2 -translate-x-1/2 text-sm transition-colors duration-300 whitespace-nowrap", 
                  selectedIndex.value === index
                    ? 'text-brand-main font-medium'
                    : 'text-gray-400'
                ])
                    }, _toDisplayString(c.label), 3)
                  ], 8, _hoisted_8)
                }), 64))
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", {
                    class: "absolute -top-2 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-b-[10px] border-b-brand-main transition-all duration-300",
                    style: _normalizeStyle({
                  left: `calc(${
                    (selectedIndex.value * 100) / 7 + 100 / 14
                  }% - 10px)`,
                })
                  }, null, 4),
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)("components.diamonds.details.color.descriptions." + colors[selectedIndex.value].key)), 1)
                ])
              ])
            ], 544)
          ]))
    ], 2)
  ], 2))
}
}

})